import { useEffect, useRef, useState } from "react";
import ConferencePage from "./components/ConferencePage";
import { getNavatarsByHospital } from "./context/navatarAPI";
import { getDoctor } from "./context/doctorAPI";
import dayjs from "dayjs";
import { CircleUser } from "lucide-react";
import { SocketProvider } from "./context/SocketProvider";

const Navatar = {
  navatarId: 1,
  name: "Navatar01",
  hospital_id: 13,
  isVideoOn: true,
  isAudioOn: true,
};

export default function App() {
  const [upcomingBooking, setUpcomingBooking] = useState(null);
  const [doctorName, setDoctorName] = useState("");
  const [joined, setJoined] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const res = await getNavatarsByHospital(Navatar.hospital_id);

        const now = dayjs();
        const booking = res.data.find((b) => {
          const start = dayjs(`${b.date} ${b.start_time}`);
          const end = dayjs(`${b.date} ${b.end_time}`);

          if (!start.isValid() || !end.isValid()) {
            console.error(
              "Invalid date format",
              b.date,
              b.start_time,
              b.end_time
            );
            return false;
          }

          return (
            b.navatar_id === Navatar.navatarId &&
            start.subtract(30, "minute").isBefore(now) &&
            end.isAfter(now)
          );
        });

        if (
          !upcomingBooking ||
          !booking ||
          upcomingBooking.booking_id !== booking.booking_id
        ) {
          setUpcomingBooking(booking || null);
        }

        if (!booking || joined) return;

        const alreadyJoined = localStorage.getItem("navatar-auto-joined");

        const bookingIdStr = String(booking.booking_id);
        const start = dayjs(`${booking.date} ${booking.start_time}`);
        const diffToStart = start.diff(now, "minute", true);

        if (diffToStart <= 0 && bookingIdStr !== alreadyJoined) {
          setJoined(true);
          localStorage.setItem("navatar-auto-joined", bookingIdStr);
        }
      } catch (err) {
        console.error("Error fetching bookings", err);
      }
    };

    fetchBookings();
    const interval = setInterval(fetchBookings, 15000);
    return () => {
      clearInterval(interval);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [joined, upcomingBooking]);

  useEffect(() => {
    const fetchDoctorName = async () => {
      if (upcomingBooking?.doctor_id) {
        try {
          const res = await getDoctor(upcomingBooking.doctor_id);
          setDoctorName(res.data.name);
        } catch (err) {
          console.error("Error fetching doctor name", err);
          setDoctorName("Unknown Doctor");
        }
      }
    };

    fetchDoctorName();
  }, [upcomingBooking]);

  const handleJoin = () => {
    setJoined(true);
    if (upcomingBooking) {
      localStorage.setItem(
        "navatar-auto-joined",
        String(upcomingBooking.booking_id)
      );
    }
  };

  const handleLeave = () => {
    setJoined(false);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    if (upcomingBooking) {
      localStorage.setItem(
        "navatar-auto-joined",
        String(upcomingBooking.booking_id)
      );
    }
  };

  if (joined && upcomingBooking) {
    const user = {
      name: Navatar.name,
      email: `${Navatar.name}@conference.com`,
      isVideoOn: Navatar.isVideoOn,
      isAudioOn: Navatar.isAudioOn,
    };
    return (
      <SocketProvider>
        <ConferencePage
          user={user}
          room={String(upcomingBooking.doctor_id)}
          onLeave={handleLeave}
        />
      </SocketProvider>
    );
  }

  return (
    <div className="navatar-interface">
      {upcomingBooking ? (
        <>
          <h1 className="title">{Navatar.name}</h1>
          <div className="avatar">
            <CircleUser size={500} />
          </div>
          <div className="session">
            <span>
              <h3> {doctorName || "Loading..."}</h3>
            </span>
            <p>
              {dayjs(
                `${upcomingBooking.date} ${upcomingBooking.start_time}`
              ).format("HH:mm")}{" "}
              -{" "}
              {dayjs(
                `${upcomingBooking.date} ${upcomingBooking.end_time}`
              ).format("HH:mm")}
            </p>

            {dayjs(
              `${upcomingBooking.date} ${upcomingBooking.start_time}`
            ).diff(dayjs(), "minute") <= 10 && (
              <button className="join-btn" onClick={handleJoin}>
                Join Call
              </button>
            )}
          </div>
        </>
      ) : (
        <h1>No upcoming session.</h1>
      )}
    </div>
  );
}
